import { Injectable } from "@angular/core";
import {  ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { Observable } from "rxjs";
import { UserService } from "../common-services/user.services";
import { AuthenticationService } from "../data-services/authentication.service";

@Injectable({
    providedIn: 'root'
})
export class AuthenticationGuard {

    constructor(
        private router: Router,
        private userService: UserService,
        private authenticationService: AuthenticationService
    ) { }

    /**
     * Check if the user is logged in and (for dashboard) profile is completed.
     */
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        try {
            const isLoggedIn = this.userService.isLoggedIn();
            const currentUser = this.userService.currentUserCredantials;
            const hasTokens = !!(currentUser?.token || currentUser?.refreshToken) || isLoggedIn;
            // Dashboard: require login and no pending password change. Profile completion (NID+DOB) is shown as a dialog on dashboard.
            if (state.url.startsWith('/dashboard')) {
                if (!hasTokens) {
                    this.redirectToLogin(state.url);
                    return false;
                }
                if (currentUser?.requireChangePassword) {
                    this.router.navigate(['/authentication/reset-password'], {
                        queryParams: { userId: currentUser.userId ?? '', requireChangePassword: 'true' },
                        replaceUrl: true
                    }).then(() => window.location.reload());
                    return false;
                }
                return true;
            }

            if (hasTokens) {
                return true;
            }

            if (!hasTokens) {
                this.redirectToLogin(state.url);
                return false;
            }

            return true;
        } catch (error) {
            console.error('Error in AuthenticationGuard:', error);
            this.router.navigate(['/authentication/login']).then(() => {
              window.location.reload();
            });
            return false;
        }
    }

    private redirectToLogin(returnUrl: string): void {
        if (returnUrl && returnUrl !== '/authentication/login' && returnUrl !== '/dashboard') {
            try {
                localStorage.setItem('returnUrl', returnUrl);
            } catch (e) {
                console.warn('Could not store returnUrl:', e);
            }
        }
        this.router.navigate(['/authentication/login']).then(() => {
            window.location.reload();
        });
    }
}
